import React, { type FC, type HTMLAttributes, type ReactNode } from 'react';

import { type ButtonProps } from '@/components/buttons/button';
import { ParamLink } from '@/components/links/param-link';
import { cn } from '@/utils/class-name';

interface Props extends HTMLAttributes<HTMLElement> {
    theme: ButtonProps['theme'];
    icon?: ButtonProps['icon'];
    children: ReactNode;
    className?: string;
}

interface HrefProp {
    href: string;
    target?: '_blank';
    to?: never;
}

interface ToProp {
    to: string;
    href?: never;
}

type ButtonLinkProps = Props & (HrefProp | ToProp);

export const ButtonLink: FC<ButtonLinkProps> = ({ theme, icon, href, to, className, children, ...props }) => {
    const classes = cn(`button ${theme}-button`, icon && `${icon}-icon`, className);

    if (href) {
        return (
            <a {...props} href={href} className={classes}>
                <span className="button-content">{children}</span>
            </a>
        );
    }

    if (to) {
        return (
            <ParamLink {...props} to={to} className={classes}>
                <span className="button-content">{children}</span>
            </ParamLink>
        );
    }

    return null;
};
